module.exports = __webpack_public_path__ + "img/4.beb9f17c.jpg";